import React from "react";
import "./tc.css";
import Nav from "../nav.js";
import MetaData from "../MetaData.js";

export default function Policy() {
  return (
    <>
      <MetaData title="Privacy Policy | GLOCRE Private Limited" />
      <Nav />
      {/* Privacy Policy */}
      <body className="body-pp-glc">
        <section className="container">
          {/* Heading */}
          <div className="heading-pp-glc">
            <h1>Privacy Policy </h1>
            <h4>Effective Date: 26-02-2026</h4>
            <h4>Last Updated: 01-08-2026 </h4>
            <p>
              Glocre Private Limited respects your privacy and is committed to protecting your Digital Personal Data in accordance with the Digital Personal Data Protection Act, 2023 ("DPDPA") and other applicable laws. This Privacy Policy explains how we collect, process, store, use, disclose, and safeguard your personal data when you access or use our website, www.glocre.com, and any related products or services. By accessing or using our website, you acknowledge that you have read and understood this Privacy Policy and consent to the processing of your personal data as described here in.
            </p>
          </div>
          {/* Contents */}
          <div className="">
            <div className="contents-pp-glc">
              <h6>1. Definitions </h6>
              <p>
                For the purposes of this Privacy Policy, "Personal Data" means any data about an individual who is identifiable by or in relation to such data. "Data Principal" refers to the individual to whom the personal data relates. "Data Fiduciary" means Glocre Private Limited, which determines the purpose and means of processing personal data. "Processing" includes any operation performed on personal data, such as collection, recording, organization, storage, use, sharing, disclosure, retrieval, modification, or deletion.
              </p>

            </div>
            <div className="contents-pp-glc">
              <h6>2. Personal Data We Collect </h6>
              <p>
                We may collect various categories of personal data to provide our products and services effectively. This includes identity and contact information such as your full name, email address, mobile number, postal address, and business details. We may also collect account-related information such as usernames, passwords, customer profiles, and order history to facilitate account management and service delivery.
                </p>
                <p>
                  In connection with purchases made through our website, we may collect transaction-related information including billing details, payment references, purchase records, and refund information. However, payment card information is processed directly by authorized payment service providers such as Razorpay, and Glocre does not store your complete payment card details unless required by law.
                </p>
                <p>
                We may automatically collect technical information including your IP address, browser type, device information, operating system, network details, website usage patterns, search activities, and pages visited. Where enabled by you, we may also collect location information to provide localized services, offers, and content tailored to your geographic location.
              </p>

            </div>
            <div className="contents-pp-glc">
              <h6>3. Purpose of Processing</h6>
              <p>
                We process your personal data only for lawful purposes. The information collected is used to create and manage user accounts, process purchases, deliver products and services, handle returns and refunds, and provide customer support. We may also process personal data to verify identities, prevent fraud, authenticate users through one-time passwords (OTP), secure our systems, and detect unauthorized activities.
                <p>
                  Your information may be used to comply with applicable legal, regulatory, accounting, and taxation requirements. We may also send service-related communications such as order confirmations, shipping updates, security alerts, account notifications, and customer support responses.
                </p>
                Where you have provided your consent, we may use your contact information to send promotional communications, product recommendations, special offers, surveys, newsletters, and marketing updates. You may withdraw your consent for marketing communications at any time.
              </p>

            </div>
            <div className="contents-pp-glc">
              <h6>4. Consent </h6>
              <p>
                Where required under applicable law, we will seek your consent before collecting and processing your personal data. Consent will be obtained through clear and affirmative actions, and you will be informed about the purposes for which your personal data is being processed.
              </p>
              <p>
                You may withdraw your consent at any time by contacting us using the details provided in this Privacy Policy. Withdrawal of consent will not affect the legality of processing carried out before such withdrawal. However, certain services may become unavailable where the processing of personal data is necessary for their provision.
              </p>


            </div>
            <div className="contents-pp-glc">
              <h6>5. Sharing of Personal Data </h6>
              <p>
                Glocre does not sell, rent, or trade your personal data. We may share your personal data with trusted third-party service providers who assist us in delivering our services. These may include payment processors such as Razorpay, communication and authentication providers, cloud hosting providers such as AWS, logistics partners, analytics providers, and technology service providers.
              </p>
              <p>
                We may also disclose personal data when required to comply with applicable laws, court orders, legal proceedings, governmental requests, regulatory requirements, or to protect our legal rights, business interests, customers, employees, or the general public. All third parties receiving personal data from us are expected to maintain appropriate security safeguards and process personal data only for authorized purposes.
              </p>

            </div>
            <div className="contents-pp-glc">
              <h6>6. Data Retention and Deletion </h6>
              <p>
                We retain personal data only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, provide our services, comply with legal and regulatory obligations, resolve disputes, and enforce our agreements. Once personal data is no longer necessary for these purposes, we will securely delete, anonymize, or de-identify the information unless retention is required by applicable law.
              </p>

            </div>


            <div className="contents-pp-glc">
              <h6>7. Children's Personal Data</h6>
              <p>
                Our services are not directed toward children. Where required under applicable law, we will obtain verifiable consent from a parent or lawful guardian before processing the personal data of a child. We do not knowingly engage in tracking, behavioral monitoring, profiling, or targeted advertising directed toward children in violation of applicable laws.
              </p>

            </div>


            <div className="contents-pp-glc">
              <h6>8. Cookies and Similar Technologies</h6>
              <p>
                Our website uses cookies and similar technologies to provide essential website functionality, improve user experience, remember preferences, analyze website performance, and enhance service quality. Cookies may help us recognize returning users, maintain login sessions, and understand user interactions with our website.
              </p>

              <p>You may control or disable cookies through your browser settings. However, disabling certain cookies may affect the functionality and performance of our website. Where required by applicable law, we will obtain your consent before deploying non-essential cookies or tracking technologies.

              </p>

            </div>

            <div className="contents-pp-glc">
              <h6>9. Security Measures</h6>
              <p>
                We implement reasonable technical, administrative, and organizational safeguards to protect personal data against unauthorized access, disclosure, alteration, loss, misuse, or destruction. These measures include secure socket layer (SSL/TLS) encryption, access controls, authentication mechanisms, secure infrastructure, monitoring systems, and periodic security reviews.
              </p>

              <p>While we make every reasonable effort to protect personal data, no system of transmission over the internet or electronic storage can be guaranteed to be completely secure. Accordingly, we cannot guarantee absolute security of personal data.

              </p>

            </div>

            <div className="contents-pp-glc">
              <h6>10. Your Rights as a Data Principal</h6>
              <p>
                Subject to applicable law, you have the right to obtain information regarding the personal data we process about you and the purposes for which such data is processed. You may request correction of inaccurate or incomplete personal data and seek erasure of personal data that is no longer required for the purposes for which it was collected.
              </p>
              <p>You also have the right to withdraw consent where processing is based on consent and to raise concerns regarding the manner in which your personal data is handled. Additionally, you may nominate another individual to exercise your rights on your behalf in accordance with applicable law.

              </p>

            </div>

            <div className="contents-pp-glc">
              <h6>11. Grievance Redressal</h6>
              <p>
                If you have any questions, concerns, complaints, or requests relating to this Privacy Policy or the processing of your personal data, you may contact our Grievance Officer by email at support@glocre.com. To facilitate timely processing, please include the subject line "Privacy Request – Glocre Account" and send your request from your registered email address wherever possible.
              </p>

              <p>We will review and address your grievance within the timelines prescribed under applicable law. If you are not satisfied with our response, you may seek recourse through the appropriate authority, including the Data Protection Board of India, where applicable.</p>



            </div>

            <div className="contents-pp-glc">
              <h6>12. Cross-Border Transfers</h6>
              <p>
                Where personal data is transferred outside India, such transfers will be carried out in accordance with applicable legal requirements, government notifications, and safeguards prescribed under the Digital Personal Data Protection Act, 2023. We will take reasonable measures to ensure that such data remains protected and is processed only for authorized purposes.
              </p>


            </div>

            <div className="contents-pp-glc">
              <h6>13. Changes to this Privacy Policy</h6>
              <p>
                We may revise this Privacy Policy from time to time to reflect changes in our business practices, legal requirements, technological developments, or service offerings. Any modifications will be published on this page along with the updated "Last Updated" date. Your continued use of our website and services following such updates constitutes your acknowledgment of the revised Privacy Policy.
              </p>


            </div>

            <div className="contents-pp-glc">
              <h6>14. Contact Us</h6>
              <p>
                For any questions regarding this Privacy Policy or our privacy practices, please contact us at support@glocre.com 
              </p>
              <p>
                We are committed to addressing privacy concerns promptly and transparently and to protecting your personal data in accordance with applicable law.
              </p>


            </div>


          </div>
        </section>
      </body>
    </>
  );
}
